import React from "react";
import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";

const ViewDocuments = ({ setViewDocument, SelectedData }) => {
  const onClose = () => {
    setViewDocument(false);
  };

  return (
    <Container>
      <div className="flex items-center justify-between bg-[#0078BD] py-4 px-4">
        <Title className="text-white">Documents</Title>
        <button onClick={onClose}>
          <MdClose color="white" size={24} />
        </button>
      </div>
      <div className="px-6 py-4 h-full flex flex-col gap-6 relative">
        <Wrapper>
          <SectionTitle>Invoice Document</SectionTitle>
          <DocumentCard>
            <Section>
              <DocumentValue>{SelectedData?.invoice || "Invoice Document"}</DocumentValue>
            </Section>
          </DocumentCard>

          <SectionTitle>Warranty Document</SectionTitle>
          <DocumentCard>
            <Section>
              <DocumentValue>{SelectedData?.Warranty || "Warranty Document"}</DocumentValue>
            </Section>
          </DocumentCard>

          <SectionTitle>Assets Document</SectionTitle>
          <DocumentCard>
            <Section>
              <DocumentValue>{SelectedData?.assets || "Asset Images"}</DocumentValue>
            </Section>
          </DocumentCard>
        </Wrapper>
      </div>
    </Container>
  );
};

const Wrapper = tw.div`grid gap-5`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
const Section = tw.div`py-1`;
const SectionTitle = tw.h2`text-md font-semibold text-gray-500 `;
const DocumentCard = tw.div`bg-gray-50 border border-gray-200 rounded-xl p-8 shadow-sm`;
// const DocumentCard = tw.div``;
const DocumentValue = tw.span`block text-gray-800 font-medium text-center`;

export default ViewDocuments;

// import React from "react";
// import tw from "tailwind-styled-components";
// import { MdClose } from "react-icons/md";

// const ViewDocuments = ({ setViewDocument, SelectedData }) => {
//   const onClose = () => {
//     setViewDocument(false);
//   };

//   return (
//     <Container>
//       <div className="flex items-center justify-between bg-[#0078BD] py-4 px-4">
//         <Title className="text-white">{"Documents"}</Title>
//         <button onClick={onClose}>
//           <MdClose color="white" size={24} />
//         </button>
//       </div>
//       <div className="px-6 h-full flex flex-col justify-between py-4 relative">
//         <Wrapper>
//           <SectionTitle>Invoice</SectionTitle>
//           <Section>
//             <Row>
//               {/* <Label>Asset Name</Label> */}
//               <Value>{SelectedData?.invoice || "Invoice Document"}</Value>
//             </Row>
//           </Section>

//           <SectionTitle>Warranty</SectionTitle>
//           <Section>
//             <Row>
//               <Value>{SelectedData?.Warranty || "Warranty Document"}</Value>
//             </Row>
//           </Section>
//           <SectionTitle>Assets</SectionTitle>
//           <Section>
//             <Row>
//               <Value>{SelectedData?.assets || "Asset Images"}</Value>
//             </Row>
//           </Section>
//         </Wrapper>
//       </div>
//     </Container>
//   );
// };

// const Wrapper = tw.div`grid gap-2 my-0`;
// const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
// const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
// const Section = tw.div``;
// const SectionTitle = tw.h2`text-lg font-semibold text-gray-700`;
// const Row = tw.div`flex justify-between py-1 md:p-2`;
// const Label = tw.label`text-sm text-gray-500 font-normal`;
// const Value = tw.span`text-gray-800 font-medium`;

// export default ViewDocuments;
